import styled from '@emotion/styled';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { config } from 'src/config/config';
import { Dispatch } from 'src/config/rootStore';
import { Modal } from 'src/shared/components/Modal';
import { color, font, mediaQueries } from 'src/shared/styles/variables';

import { isInviteDependentModalVisible } from '../selectors/userSelectors';

import { Trans, useTranslation } from 'react-i18next';
import appStoreButton from 'src/public/img/btn-appstore.svg';
import googlePlayButton from 'src/public/img/btn-google-play.svg';
import img from 'src/public/img/marginalia-teamwork.svg';

const StyledModal = styled(Modal)({
    '.ant-modal-content': {
        borderRadius: 7.5,

        '.ant-modal-body': {
            padding: 0,
        },
    },
});

const Wrapper = styled.div({
    padding: '36px 40px',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    [mediaQueries.md]: {
        padding: '36px 24px 26px',
    },
});

const Title = styled.h3(
    {
        textAlign: 'center',
        color: color.ebonyClay,
    },
    font.black(font.size.largeExtended),
);

const Description = styled.p(
    {
        textAlign: 'center',
        lineHeight: '26px',
        color: color.blueBayoux,
    },
    font.book(font.size.medium),
);

const DescriptionBold = styled.span(
    {
        color: color.blueBayoux,
    },
    font.heavy(font.size.medium),
);

const DownloadAppText = styled.p(
    {
        marginTop: 28,
        textAlign: 'center',
        color: color.blueBayoux,
    },
    font.medium(font.size.base),
);

const ButtonsWrapper = styled.div({
    display: 'flex',
    justifyContent: 'center',
    marginTop: 14,
});

const StoreButton = styled.img({
    cursor: 'pointer',
    width: 134,
});

export const InviteDependentModal: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch<Dispatch>();
    const modalVisible = useSelector(isInviteDependentModalVisible);

    const handleStoreButtonClick = (link: string) => () => {
        window.open(link, '_blank');
    };

    return (
        <StyledModal
            visible={modalVisible}
            footer={null}
            width={650}
            onCancel={dispatch.user.hideInviteDependentModal}
            centered
        >
            <Wrapper>
                <img src={img} />

                <Title>{t('user:invite_dependent.title')}</Title>
                <Description>
                    <Trans
                        t={t}
                        ns="user"
                        i18nKey="invite_dependent.description"
                        components={[
                            <DescriptionBold key="invite_dependent.description_0">
                                "Settings"
                            </DescriptionBold>,
                        ]}
                    />
                </Description>

                <DownloadAppText>{t('user:invite_dependent.download_app')}</DownloadAppText>

                <ButtonsWrapper>
                    <StoreButton
                        src={appStoreButton}
                        style={{ marginRight: 15 }}
                        onClick={handleStoreButtonClick(config.iOSAppStoreURL)}
                    />
                    <StoreButton
                        src={googlePlayButton}
                        onClick={handleStoreButtonClick(config.AndroidGooglePlayStoreURL)}
                    />
                </ButtonsWrapper>
            </Wrapper>
        </StyledModal>
    );
};
